module.exports = __webpack_public_path__ + "static/img/image078.0a6a596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image078.png
// module id = b+MF
// module chunks = 1